/* istanbul ignore file */
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import CookiesBlocker from "./components/CookiesBlocker/CookiesBlocker";
import reportWebVitals from "./reportWebVitals";
import AuthProviderWithHistory from "./components/AuthProviderWithHistory";
import { CookiesProvider } from "react-cookie";
import { UnloadAppProvider } from "./components/UnloadAppProvider";


try {
  ReactDOM.render(
    <Router>
      <CookiesProvider>
        <AuthProviderWithHistory>
          <UnloadAppProvider>
            <App />
          </UnloadAppProvider>
        </AuthProviderWithHistory>
      </CookiesProvider>
    </Router>
    , document.getElementById("root")
  );
} catch {
  ReactDOM.render(<CookiesBlocker />, document.getElementById("root"));
}

reportWebVitals();